'use strict';

/**
 * @ngdoc type
 * @name mx.shell.SearchContext
 * @module mx.shell
 *
 * @description
 * An object containing search context information (Search context model)
 * Constructor accepts options object that may contain properties values like:
 * ```javascript
	 var options = {
	    name: 'some name',
	    title: 'some title',
	    routeName: 'route name',
	    parameters: {}
	 };
	 var context = new mx.shell.SearchContext(options);
 * ```

 * @property {string} name - Gets or sets name of the context. Default: ''
 * @property {string} title - Gets or sets title (display name) of the context. Default: ''
 * @property {string} routeName - Gets or sets route name for the context or route Url. Default: ''
 * @property {object} parameters - Search parameters object that contains data like columns definition etc. May vary for different applications. Default: {}
 */
function MxSearchContext(options) {
	Object.defineProperty(this, 'name', {
		enumerable: true,
		writable: true,
		value: options.name || '',
	});
	Object.defineProperty(this, 'title', {
		enumerable: true,
		writable: true,
		value: options.title || '',
	});
	Object.defineProperty(this, 'routeName', {
		enumerable: true,
		writable: true,
		value: options.routeName || '',
	});
	Object.defineProperty(this, 'parameters', {
		enumerable: true,
		writable: true,
		value: options.parameters || {},
	});

	Object.defineProperty(this, 'showInGlobalSearch', {
		enumerable: true,
		writable: true,
		value: !!(options.showInGlobalSearch === undefined || options.showInGlobalSearch),
	});
}

window.mx = window.mx || {};
window.mx.shell = window.mx.shell || {};
window.mx.shell.SearchContext = MxSearchContext;
